import { useMainCurrenciesQuery } from '../data-access/queries/useMainCurrenciesQuery';

import { useFanTokenConversionRates } from './useFanTokenConversionRates';
import { useFanTokenOfferings } from './useFanTokenOfferings';
import { useMarketAvailability } from './useMarketAvailability';
import { useWalletFormatter } from './useWalletFormatter';

type UseCurrencyInfoParams = {
	amount?: number;
	currencyId?: string;
	partnerId?: string;
};

export const useCurrencyInfo = ({ amount, currencyId, partnerId }: UseCurrencyInfoParams) => {
	const { data: currencies } = useMainCurrenciesQuery();
	const { altCurrency, defaultCurrency } = currencies ?? {};
	const { conversionRates, isConversionRatesLoading } = useFanTokenConversionRates(
		currencyId,
		defaultCurrency,
		altCurrency
	);
	const [defaultCurrencyRates, altCurrencyRates] = conversionRates || [];

	const { data: fanTokenOfferings, isLoading: isFTOLoading } = useFanTokenOfferings({
		'partnerIds[]': partnerId ? [partnerId] : []
	});

	const {
		availableMarketsData,
		isBuyEnabled,
		isLoading: isAvailableMarketLoading,
		isMarketAvailable,
		isSellEnabled
	} = useMarketAvailability(currencyId);

	const { formatEvolutionPercentage } = useWalletFormatter();

	const isFTO = fanTokenOfferings?.find(offering => offering?.fanToken?.partnerId === partnerId);

	return {
		currentPrice: defaultCurrencyRates?.formatPrice(1),
		isCurrencyInfoLoading: isAvailableMarketLoading || isConversionRatesLoading || isFTOLoading,
		isMarketAvailable: isMarketAvailable && (isSellEnabled || isBuyEnabled),
		isPercentagePositive: !availableMarketsData?.[0]?.ticker?.evolutionPercentage?.includes('-'),
		isPercentageZero: Number(availableMarketsData?.[0]?.ticker?.evolutionPercentage) === 0,
		marketEvolutionPercentage: formatEvolutionPercentage(availableMarketsData?.[0]?.ticker?.evolutionPercentage),
		showAmountLabel: !isFTO || !!(isFTO && amount && amount > 0),
		subCurrentPrice: altCurrencyRates?.formatPrice(1)
	};
};
